import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../API";
import { isAutheticated } from "../auth/authhelper";
import { Link } from "react-router-dom/cjs/react-router-dom";

const cardData = [
    { key: "userManual", title: "User Manual" },
    { key: "processPresentation", title: "Process Presentation" },
    { key: "socialMediaTraction", title: "Social Media Traction Partner" },
];

export default function Help() {
    const { token } = isAutheticated();

    const [pdfs, setPdfs] = useState({
        userManual: null,
        processPresentation: null,
        socialMediaTraction: null,
    });
    const [selectedFiles, setSelectedFiles] = useState({});
    const [uploading, setUploading] = useState({});
    const [progress, setProgress] = useState({});
    const [activePdf, setActivePdf] = useState(null); // key of PDF to display
    const [loading, setLoading] = useState(true);

    // Fetch all PDFs
    useEffect(() => {
        const fetchAllPdfs = async () => {
            try {
                const res = await axios.get(`${API}/api/help/getAllPdfs`);
                if (res.data?.pdfs) {
                    const formatted = Object.keys(res.data.pdfs).reduce((acc, key) => {
                        acc[key] = res.data.pdfs[key]?.fileUrl || null;
                        return acc;
                    }, {});
                    setPdfs(formatted);
                }
            } catch (error) {
                console.error("Error fetching PDFs:", error);
                alert("Failed to load PDFs.");
            } finally {
                setLoading(false);
            }
        };

        fetchAllPdfs();
    }, []);

    const handleFileSelect = (e, key) => {
        const file = e.target.files[0];
        if (!file) return;

        const allowedTypes = [
            "application/pdf",


            // Word
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

            // PowerPoint
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",

            // Excel
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ];

        if (!allowedTypes.includes(file.type)) {
            alert("Only PDF, Word, PowerPoint, or Excel files are allowed!");
            return;
        }

        setSelectedFiles((prev) => ({ ...prev, [key]: file }));
    };


    // Upload PDF with progress
    const handleUpload = async (key) => {
        const file = selectedFiles[key];
        if (!file) return;

        setUploading((prev) => ({ ...prev, [key]: true }));
        setProgress((prev) => ({ ...prev, [key]: 0 }));

        const formData = new FormData();
        formData.append("pdf", file);
        formData.append("type", key);

        try {
            const res = await axios.post(`${API}/api/help/uploadPdf`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (event) => {
                    const percent = Math.round((event.loaded * 100) / event.total);
                    setProgress((prev) => ({ ...prev, [key]: percent }));
                },
            });

            if (res.data?.pdf?.fileUrl) {
                setPdfs((prev) => ({ ...prev, [key]: res.data.pdf.fileUrl }));
                setSelectedFiles((prev) => ({ ...prev, [key]: null }));
                alert(`${key} PDF uploaded successfully!`);
            }
        } catch (err) {
            console.error("Upload error:", err);
            alert("Failed to upload PDF.");
        } finally {
            setUploading((prev) => ({ ...prev, [key]: false }));
            setProgress((prev) => ({ ...prev, [key]: 0 }));
        }
    };

    // Open PDF viewer modal
    const handleCardClick = (key) => {
        if (pdfs[key]) setActivePdf(key);
    };

    if (loading) {
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid text-center py-5">
                        <h4>Loading Help PDFs...</h4>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Resources - Help</h4>

                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">SoComOTT</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            Resources - Help
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className="container py-4">
                                    {/* <h2 className="mb-5 text-center fw-bold text-primary">
                            Help & Resources
                        </h2> */}

                                    {/* PDF Cards */}
                                    <div className="row justify-content-center g-4">
                                        {cardData.map((card) => {
                                            const hasPDF = Boolean(pdfs[card.key]);
                                            const selectedFile = selectedFiles[card.key];
                                            const isUploading = uploading[card.key];
                                            const uploadProgress = progress[card.key] || 0;

                                            return (
                                                <div className="col-md-4" key={card.key}>
                                                    <div
                                                        className={`card h-100 text-center border border-2 shadow-sm rounded-4 p-4 ${hasPDF ? "border-success" : "border-light"
                                                            } card-hover`}
                                                        style={{
                                                            cursor: hasPDF ? "pointer" : "default",
                                                            transition: "0.3s",
                                                            minHeight: "250px",
                                                        }}
                                                    // onClick={() => hasPDF && handleCardClick(card.key)}
                                                    >
                                                        <div className="card-body d-flex flex-column justify-content-center align-items-center">
                                                            {/* <h2 className="card-title mb-4 fw-semibold text-dark">
                                                    {card.title}
                                                </h2> */}

                                                            {/* hidden file input */}
                                                            <input
                                                                type="file"
                                                                // accept="application/pdf"
                                                                accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx"
                                                                id={`file-${card.key}`}
                                                                style={{ display: "none" }}
                                                                onChange={(e) => handleFileSelect(e, card.key)}
                                                            />

                                                            {!hasPDF && selectedFile && (
                                                                <button
                                                                    className="btn btn-outline-primary px-4"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        document
                                                                            .getElementById(`file-${card.key}`)
                                                                            .click();
                                                                    }}
                                                                >
                                                                    Select Word Doccument
                                                                </button>
                                                            )}

                                                            {selectedFile && !hasPDF && (
                                                                <div>
                                                                    <p className="small mb-2 text-muted">
                                                                        {selectedFile.name}
                                                                    </p>
                                                                    <div className="d-flex flex-column gap-2 align-items-center">
                                                                        <div className="d-flex gap-2">
                                                                            <button
                                                                                className="btn btn-primary btn-sm"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUpload(card.key);
                                                                                }}
                                                                                disabled={isUploading}
                                                                            >
                                                                                {isUploading ? "Uploading..." : "Upload"}
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setSelectedFiles((prev) => ({
                                                                                        ...prev,
                                                                                        [card.key]: null,
                                                                                    }));
                                                                                }}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </div>

                                                                        {isUploading && (
                                                                            <div className="progress w-100 mt-1">
                                                                                <div
                                                                                    className="progress-bar"
                                                                                    role="progressbar"
                                                                                    style={{ width: `${uploadProgress}%` }}
                                                                                    aria-valuenow={uploadProgress}
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100"
                                                                                >
                                                                                    {uploadProgress}%
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {hasPDF && (
                                                                <div className="d-flex flex-column align-items-center gap-2 mt-3">
                                                                    {/* View PDF */}
                                                                    <button
                                                                        className="btn btn-success px-4"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (pdfs[card.key]) {
                                                                                // Direct Download
                                                                                const link = document.createElement("a");
                                                                                link.href = pdfs[card.key];
                                                                                link.download = card.title;
                                                                                link.click();
                                                                            } else {
                                                                                alert("File not available!");
                                                                            }
                                                                        }}
                                                                    >
                                                                        Download {card.title}
                                                                    </button>



                                                                    {/* Replace PDF Button */}
                                                                    {/* <button
                                                            className="btn btn-warning px-4"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                document.getElementById(`file-${card.key}`).click();
                                                            }}
                                                        >
                                                            Replace PDF
                                                        </button> */}
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* PDF Viewer Modal */}
                                    {activePdf && pdfs[activePdf] && (
                                        <div
                                            className="modal d-block"
                                            style={{
                                                backgroundColor: "rgba(0,0,0,0.5)",
                                                position: "fixed",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                zIndex: 1050,
                                                overflow: "auto",
                                                padding: "40px 20px",
                                            }}
                                        >
                                            <div
                                                className="modal-dialog"
                                                style={{ maxWidth: "950px", margin: "auto" }}
                                            >
                                                <div className="modal-content p-3">
                                                    <div className="modal-header d-flex justify-content-between align-items-center">
                                                        <h5 className="modal-title">
                                                            {cardData.find((c) => c.key === activePdf).title}
                                                        </h5>
                                                        <button
                                                            className="btn btn-outline-secondary btn-sm"
                                                            onClick={() => setActivePdf(null)}
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                    <div style={{ height: "600px", border: "1px solid #ddd" }}>
                                                        <iframe
                                                            src={pdfs[activePdf]}
                                                            title={activePdf}
                                                            width="100%"
                                                            height="100%"
                                                        ></iframe>
                                                    </div>
                                                    <div className="mt-2 text-end">
                                                        <a
                                                            href={pdfs[activePdf]}
                                                            download
                                                            className="btn btn-outline-primary"
                                                        >
                                                            Download PDF
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
